import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { bootstrapChains } from './lib/chain-bootstrap'

// Show a lightweight loading spinner while chains bootstrap
const rootEl = document.getElementById('root')!

const wrapper = document.createElement('div')
wrapper.style.cssText =
  'display:flex;align-items:center;justify-content:center;height:100vh;background:#0a0a0f;'

const spinner = document.createElement('div')
spinner.style.cssText =
  'width:32px;height:32px;border:3px solid #1e1e2e;border-top-color:#818cf8;border-radius:50%;animation:spin .8s linear infinite;'

const style = document.createElement('style')
style.textContent = '@keyframes spin{to{transform:rotate(360deg)}}'

wrapper.appendChild(spinner)
wrapper.appendChild(style)
rootEl.appendChild(wrapper)

// Bootstrap chains, then dynamically import the app so wagmi.ts
// evaluates after getBootstrapResult() has data.
bootstrapChains().then(async () => {
  rootEl.removeChild(wrapper)
  const { default: App } = await import('./App')
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
